import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M12 1c4.418 0 8 3.582 8 8v5c0 1.105.895 2 2 2 1.333 0 1.333 2 0 2H2c-1.333 0-1.333-2 0-2 1.105 0 2-.895 2-2V9c0-4.418 3.582-8 8-8zm0 2C8.686 3 6 5.686 6 9v5c0 .729-.195 1.412-.535 2h13.07c-.34-.588-.535-1.271-.535-2V9c0-3.314-2.686-6-6-6zm2.595 18.502c-.537.925-1.525 1.494-2.595 1.494-1.07 0-2.058-.569-2.595-1.494-.387-.667.094-1.502.865-1.502h3.46c.77 0 1.252.835.865 1.502z"
	})
});
export default SvgBell;
